import axios from 'axios'
import { getSessionToken } from '../session'
const SCREENSHOT_SERVICE_API_URL = process.env.REACT_APP_SCREENSHOT_SERVICE_API_URL

export const SCREENSHOT_ENCODING_BINARY='binary'
export const SCREENSHOT_ENCODING_BASE64='base64'

export async function screenshot({ url, selector = null, waitFor = 2000, encoding = SCREENSHOT_ENCODING_BASE64, ...rest}) {
  const payload = { url, encoding, waitFor, ...rest }
  if (selector) {
    payload.selector = selector
  }
  return axios({
    method: 'POST',
    url: `${SCREENSHOT_SERVICE_API_URL}`,
    headers: {
      'Content-Type': 'application/json'
    },
    withCredentials: true,
    data: payload
  }).then(({ data }) => data)

}

